<template>
  <el-form
    ref="authRuleForm"
    :model="data"
    :rules="rules"
    label-width="100px"
  >
    <el-form-item label="父级权限">
      <!-- <el-select
        v-model="data.parent_id"
        :placeholder="$t('请选择')"
        clearable
        filterable
        :filter-method="parentFilter"
        @change="parentidChange"
      >
        <el-option v-for="item in parentOptions" :key="item.key" :label="item.display_name | entityToString" :value="item.key" />
      </el-select> -->
      <el-cascader
        :key="casKey"
        v-model="viewSelectId"
        :options="optionData"
        :props="{value: 'id', label: 'title' , checkStrictly: true}"
        @change="handleChange"
      />
    </el-form-item>
    <el-form-item
      label="名称"
      prop="title"
    >
      <el-input
        v-model.trim="data.title"
        placeholder="请填写权限名称"
      />
    </el-form-item>
    <el-form-item
      label="请求链接"
      prop="url"
    >
      <el-tooltip
        effect="dark"
        content="请求链接默认不用加前缀"
        placement="top"
      >
        <el-input
          v-model.trim="data.url"
          placeholder="请填写请求链接"
        >
          <template slot="prepend">
            <i class="el-icon-link" />
          </template>
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item
      label="请求方式"
      prop="method"
    >
      <el-select v-model="data.method">
        <el-option
          v-for="ite in methodOptions"
          :key="ite.key"
          :label="ite.display_name"
          :value="ite.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="标识"
      prop="slug"
    >
      <el-input
        v-model.trim="data.slug"
        placeholder="请填写标识"
      />
    </el-form-item>
    <el-form-item
      label="权限描述"
      prop="description"
    >
      <el-input
        v-model.trim="data.description"
        type="textarea"
        rows="6"
        placeholder="请填写权限描述"
      />
    </el-form-item>
    <el-form-item
      label="排序"
      prop="sort"
    >
      <el-input
        v-model.trim="data.sort"
        placeholder="请填写排序"
      />
    </el-form-item>
    <el-form-item
      label="鉴定权限"
      prop="isNeedAuth"
    >
      <el-radio-group v-model="data.isNeedAuth">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio-group v-model="data.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="submit"
      >提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  getRuleDetail,
  updateRule,
  ruleChildrenList
} from '@/api/authRule'
export default {
  name: 'AuthRuleEdit',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      all: [],
      chilren: [],
      id: '',
      casKey: Math.random(),
      // parent_id: '',
      viewSelectId: 0,
      data: {
        parent_id: null,
        title: '',
        url: '',
        method: 'GET',
        slug: '',
        description: '',
        sort: 100,
        isNeedAuth: 1,
        status: 1
      },
      optionData: [{
        id: 0,
        title: '顶级分组',
        chilren: []
      }], // 分组筛选列表
      rules: {
        parent_id: [
          { required: true, message: '父级不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请求链接不能为空', trigger: 'blur' }
        ],
        slug: [
          { required: true, message: '标识不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      },
      parentOptions: [
        { key: '0', display_name: '顶级权限' }
      ],
      parentFilterOptions: [],
      methodOptions: [
        { key: 'GET', display_name: 'GET' },
        { key: 'HEAD', display_name: 'HEAD' },
        { key: 'POST', display_name: 'POST' },
        { key: 'PUT', display_name: 'PUT' },
        { key: 'DELETE', display_name: 'DELETE' },
        { key: 'PATCH', display_name: 'PATCH' },
        { key: 'OPTIONS', display_name: 'OPTIONS' }
      ]
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        this.id = val.id
        this.fetchDatadetail()
        this.getGroupChildrenList()
        this.initData()
      },
      deep: true
    }
  },
  created() {
    this.id = this.item.id
    this.fetchDatadetail()
  },
  methods: {
    // 获取分组筛选列表
    getGroupChildrenList() {
      ruleChildrenList().then(res => {
        this.optionData = [{
          id: '0',
          title: '顶级分组'
        }, ...res.data.list]
        this.casKey = Math.random()
      })
    },
    handleChange(e) {
      this.data.parent_id = e[e.length - 1]
    },
    // 获取详情
    fetchDatadetail() {
      getRuleDetail(this.item.id).then(response => {
        if (response.data.parentid === 0) {
          this.viewSelectId = response.data.parentid.toString()
        } else {
          this.viewSelectId = response.data.parentid * 1
        }
        this.data = response.data
        this.data.parent_id = response.data.parentid
        this.getGroupChildrenList()
      })
    },
    // 提交
    submit() {
      this.$refs.authRuleForm.validate(valid => {
        if (!valid) {
          return false
        }
        const data = {
          parent_id: this.data.parent_id * 1,
          title: this.data.title,
          url: this.data.url,
          method: this.data.method,
          slug: this.data.slug,
          description: this.data.description,
          sort: this.data.sort,
          is_need_auth: this.data.isNeedAuth,
          status: this.data.status
        }
        updateRule(this.id, data).then(response => {
          this.casKey = Math.random()
          this.viewSelectId = 0
          this.optionData = [{
            id: 0,
            title: '顶级分组'
          }]
          this.getGroupChildrenList()
          this.$emit('updateList')
          this.$message({
            message: '更新权限信息成功',
            type: 'success'
          })
          this.id = null
          // this.successTip('更新权限信息成功', () => {
          //   if (this.$refs.authRuleForm !== undefined) {
          //     this.id = ''
          //     this.$refs.authRuleForm.resetFields()
          //   }
          // })
        })
      })
    }
    // async initData() {
    //   const all = await this.getAll()
    //   const children = await this.getChildren()

    //   this.all = all.data.list
    //   this.children = children.data.list

    //   this.fetchParents()
    //   this.fetchData(this.id)
    // },
    // getAll() {
    //   return getRuleChildrenList({
    //     id: 0,
    //     type: 'list'
    //   })
    // },
    // getChildren() {
    //   return getRuleChildrenList({
    //     id: this.id,
    //     type: 'ids'
    //   })
    // },
    // fetchParents() {
    //   const all = this.all
    //   const children = this.children

    //   this.parentOptions = [
    //     { key: '0', display_name: this.$t('顶级权限') }
    //   ]
    //   this.parentFilterOptions = []

    //   children.push(this.id)
    //   all.forEach(item => {
    //     if (!children.includes(item.id)) {
    //       this.parentOptions.push({
    //         key: item.id,
    //         display_name: item.spacer + ' ' + item.title + '【' + item.method + '】'
    //       })
    //     }
    //   })

    //   this.parentFilterOptions = this.parentOptions
    // },
    // fetchData(id) {
    //   getRuleDetail(id).then(response => {
    //     this.parent_id = response.data.parent_id
    //     this.data = response.data
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    // parentFilter(val) {
    //   this.data.parent_id = val
    //   if (val) {
    //     this.parentOptions = this.parentFilterOptions.filter(item => {
    //       if (!!~item.display_name.indexOf(val) ||
    //         !!~item.display_name.toUpperCase().indexOf(val.toUpperCase())
    //       ) {
    //         return true
    //       }
    //     })
    //   } else {
    //     this.parentOptions = this.parentFilterOptions
    //   }
    // },
    // parentidChange(val) {
    //   if (val) {
    //     this.parentOptions = this.parentFilterOptions
    //     this.data.parent_id = val
    //   }
    // },

  }
}
</script>
